import React, { MouseEvent, ReactNode, useMemo, useState } from 'react';
import './Badge.scss';
import PropTypes from "prop-types";
import PortalModal from '../PortalModal';
import { ASSOONASPOSSIBLEDELIVERYDATE } from '../../libraries/constants';
import { TranslateFunction } from '../../types';

interface BadgeProps {
	children?: ReactNode;
	secondary?: ReactNode;
	color?: string | {
		background?: string;
		text?: string;
		secondary?: string;
	};
	className?: string;
	hint?: string;
	size?: 'small'|''|'big';
	eobDetails?: any[];
	t?: TranslateFunction;
	onClick?: (e: MouseEvent<HTMLSpanElement>) => void;
}

const Badge = (props: BadgeProps) => {
	const {
		children,
		secondary,
		color,
		hint,
		className,
		size,
		eobDetails,
		t,
		onClick,
	} = props;

	const [showModal, setShowModal] = useState(false);

	const colors: Record<string, number | string> = useMemo(() => {
		if (typeof color === 'string') {
			return { '--color': color }
		}

		return {
			'--color': color?.background,
			'--textColor': color?.text,
			'--secondary-color': color?.secondary
		};
	}, [color]);

	return (
		<span
			className={`Badge ${children ? 'Badge--with-primary' : ''} ${secondary ? 'Badge--with-secondary' : ''} ${className ?? ''} ${size ?? ''}`}
			title={hint}
			style={colors}
			onClick={
				(e) => {
					if (eobDetails?.length > 1) {
						setShowModal(true);
					}

					onClick?.(e)
				}
			}
		>
			<span className='Badge__primary'>
				{children}
			</span>
			{secondary && (
				<span className={`Badge__secondary ${(eobDetails?.length > 1) ? 'Badge--with-eob-hover' : ""}`} >
					{secondary}
					<span className={`${eobDetails ? 'Badge--with-eob-details' : ""} ${(eobDetails?.length > 1) ? 'Badge--with-eob-hover Badge--with-eob-underlined' : ""}`}>
						{eobDetails && t ? (eobDetails?.length > 1 ? t("order.eobSeeDetails") : t("order.eobWithCharlesOn", eobDetails[0].deliveryDate != ASSOONASPOSSIBLEDELIVERYDATE ? eobDetails[0].deliveryDate : t("order.asSoonAsPossible"))) : ''}</span>
				</span>
			)
			}
			{showModal &&
				<PortalModal close={() => setShowModal(false)}>
					{eobDetails.map((eobDetail, index) => {
						return (
							<div key={index} className='Badge--with-eob-modal'>
								<p>  {t && t("order.eobModalText", eobDetail.amount, eobDetail.deliveryDate != ASSOONASPOSSIBLEDELIVERYDATE ? eobDetail.deliveryDate : t("order.asSoonAsPossible"))}</p>
							</div>
						)
					}
					)}
				</PortalModal>
			}
		</span>
	);
}

Badge.propTypes = {
	color: PropTypes.oneOfType([
		PropTypes.string,
		PropTypes.shape({
			background: PropTypes.string,
			text: PropTypes.string,
			secondary: PropTypes.string
		})
	]),
	children: PropTypes.node,
	className: PropTypes.string,
	secondary: PropTypes.any,
	hint: PropTypes.string,
	size: PropTypes.oneOf(['small', '', 'big']),
	eobDetails: PropTypes.array,
	t: PropTypes.func,
	onClick: PropTypes.func,
};

export default Badge;
